'use client';

import { Box, Divider, Typography } from '@mui/material';

import { EventResponse } from '@/types';
import { isTennisGame } from '@/utils';
import { DefaultScoreBoard } from './DefaultScoreBoard';
import { TennisScoreBoard } from './TennisScoreBoard';

interface GameScoreCardProps {
  game: EventResponse;
}

export const GameScoreCard = ({ game }: GameScoreCardProps) => {
  if (!game) return null;

  const isTennis = isTennisGame(game);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        py: { xs: 1, md: isTennis ? 2 : 4 },
      }}
    >
      <Divider
        sx={{
          position: 'absolute',
          top: { xs: '16px', md: '24px' },
          left: 0,
          right: 0,
          '&::before, &::after': { borderColor: 'divider' },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, px: { xs: 1, md: 2 } }}>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              opacity: 0.5,
              color: 'text.secondary',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              fontSize: { xs: '0.625rem', md: '0.75rem' },
            }}
          >
            Porvenix
          </Typography>
        </Box>
      </Divider>

      <Box sx={{ mt: { xs: 4, sm: 6, md: isTennis ? 6 : 0 }, width: '100%' }}>
        {isTennis ? <TennisScoreBoard game={game} /> : <DefaultScoreBoard game={game} />}
      </Box>
    </Box>
  );
};
